import { USER_CLICK, USER_KEYBOARD, USER_SET_FOCUS } from '../../../types';
import { isEscapeKeyboard, isValidateKeyboard } from '../../common/utils/keyboard';

/**
 * Handles closing modal using click or enter on buttons, and escape modal
 *
 * @param {KeyboardEvent|MouseEvent|PointerEvent} event The event that triggered the modal closing
 * @param {*} player The current player context, to send custom events to store
 * @param {Element} currentIconRef The icon that initially opened the modal
 * @param {string} closedAction The custom event associated to the current modal closing
 * @param {Function} setIsModalOpened The method that changes the modal opened state
 * @returns
 */
export const handleCloseModalButton = ({ event, player, currentIconRef, setIsModalOpened, closedAction = '' }) => {
  // For HTMLButtonElement and elements with `role="button"`, `onKeyDown` events are triggering `onClick` events
  const isKeyboardEvent = event instanceof KeyboardEvent;
  if (isKeyboardEvent && !isValidateKeyboard(event) && !isEscapeKeyboard(event)) {
    return;
  }

  if (closedAction) {
    player.userEvents$.next({
      action: closedAction,
      source: isKeyboardEvent ? USER_KEYBOARD : USER_CLICK
    });
  }

  if (currentIconRef) {
    setTimeout(() => {
      //  After closing, force focus on icon that initially opened the modal
      player.userEvents$.next({
        action: USER_SET_FOCUS,
        payload: { element: currentIconRef }
      });
    }, 100);
  }

  // Local state
  setIsModalOpened(false);
};
